export const INTEGRATION_TYPE = 'google-cm360-outbound'
export const DATA_TYPE_KEY = 'data_type'

export const DATA_TYPES = [
  { type: 'campaigns', label: 'Campaigns' },
  { type: 'placements', label: 'Placements' },
  { type: 'ads', label: 'Ads' },
  { type: 'creatives', label: 'Creatives' },
  { type: 'click_through_url', label: 'Click Through URL' },
] as const
